/* eslint-disable react/no-danger */
import DOMPurify from 'dompurify';
import { Stack } from '@mui/material';

const SanitizedMessage = ({ text, className, sx }: { text: string; className?: string; sx?: object }) => {
  const cleanHTML = DOMPurify.sanitize((text || '').replace(/\n/g, '<br/>'));
  return <Stack dangerouslySetInnerHTML={{ __html: cleanHTML }} className={className} sx={sx} />;
};

export default SanitizedMessage;
